import memoize from 'lodash/memoize';
import { exactLength, numbersSpacesAndDashes } from '../validators';

export default [
  numbersSpacesAndDashes(),
  /* memoize(exactLength(10, () => 'Organisationsnumret ska anges med 10 siffror.')), */
];
